import React from 'react';
import Logo from './components/Logo';
import { IconComponentType, IconWrapperProps } from './interfaces';

const Icon = ({ name, ...props }: IconWrapperProps) => {
  let Component: IconComponentType = () => <></>;

  switch (name) {
    case 'logo': {
      Component = Logo;
      break;
    }
  }

  return <Component {...props} />;
};

export default Icon;
